import { HierarchicalMenu } from 'react-instantsearch-dom'

export default function Taxonomy({ defaultRefinement }) {
    return (
        <div className="mb36">
            <div className="ais-Heading mb18">Kategorijos</div>
            <HierarchicalMenu
                attributes={[
                    'hierarchical_taxonomies.lvl0',
                    'hierarchical_taxonomies.lvl1',
                    'hierarchical_taxonomies.lvl2'
                ]}
                defaultRefinement={defaultRefinement}
                limit={1000}
                showParentLevel={true}
            />
        </div>
    )
}
